import React from 'react';
import {useDispatch} from 'react-redux';
import {hooks} from 'lib.front';
import {urls} from 'src/config';
import {logOut, loadingModal, openMsg} from 'src/redux-app';

export default function useLogOut() {
   const dispatch = useDispatch();
   function callbackProcesarData(data) {
      dispatch(logOut());
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
   }
   const [logOutCall] = hooks.useApiRest(
      urls.logOut,
      {
         callbackProcesarData: callbackProcesarData,
         callbackLoading: callbackLoading,
         callbackError: callbackError
      },
      {credentials: 'include'}
   );
   return logOutCall;
}
